import React, { useEffect, useState } from 'react';
import { HelpCircle, Search, Moon, Sun, LogOut, Menu } from 'lucide-react';
import { useDarkMode, useToggleDark } from '../context/DarkModeContext';
import { useAuth, hasModule } from '../context/AuthContext';
import { useModule } from '../App';
import { api } from '../lib/api';
import NotificationBell from './NotificationBell';

const ALL_MODULES = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'leads',     label: 'Leads' },
  { key: 'contacts',  label: 'Contacts' },
  { key: 'companies', label: 'Companies' },
  { key: 'email',     label: 'Email' },
  { key: 'pipeline',  label: 'Pipeline' },
  { key: 'quotes',    label: 'Loan Quotes' },
  { key: 'forms',     label: 'Forms' },
  { key: 'tasks',     label: 'Tasks' },
  { key: 'calendar',  label: 'Calendar' },
  { key: 'products',  label: 'Products' },
  { key: 'orders',    label: 'Orders' },
  { key: 'marketing', label: 'Marketing' },
  { key: 'documents', label: 'Documents' },
  { key: 'securecx',  label: 'SecureCX' },
  { key: 'payments',  label: 'Payments' },
];
// Reports, Website, Funnels and Settings live in the left Sidebar instead (see Sidebar.jsx).

const Topbar = ({ onToggleSidebar }) => {
  const darkMode = useDarkMode();
  const toggleDark = useToggleDark();
  const { user, logout } = useAuth();
  const { currentModule, setCurrentModule } = useModule();
  const [enabledGlobal, setEnabledGlobal] = useState(null);

  useEffect(() => {
    api.get('/settings/app').then((r) => setEnabledGlobal(r.data.enabled_modules)).catch(() => setEnabledGlobal(null));
  }, []);

  const isEnabledGlobally = (m) => !enabledGlobal || enabledGlobal.includes(m);
  const visible = ALL_MODULES.filter((m) => isEnabledGlobally(m.key) && hasModule(user, m.key));
  const initials = (user?.name || user?.email || '?').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();

  return (
    <div className="crm-topbar" data-testid="topbar">
      <button className="crm-burger" onClick={onToggleSidebar} data-testid="mobile-burger" aria-label="Toggle sidebar"><Menu size={16} /></button>
      <span className="crm-logo">LegacyCRM</span>
      {visible.map((m) => (
        <button key={m.key} className={`crm-nav-item${currentModule === m.key ? ' active' : ''}`} onClick={() => setCurrentModule(m.key)} data-testid={`nav-${m.key}`}>
          {m.label}
        </button>
      ))}
      <div className="crm-search" data-testid="search-bar">
        <Search size={11} style={{ opacity: 0.5 }} />
        <span>Search</span>
        <span style={{ opacity: 0.35, marginLeft: 'auto', fontSize: 10 }}>/</span>
      </div>
      <div className="crm-top-right">
        <NotificationBell />
        <div className="crm-top-icon" data-testid="help-btn"><HelpCircle size={14} /></div>
        <div className="crm-top-icon" onClick={toggleDark} data-testid="dark-mode-toggle" title={darkMode ? 'Switch to light' : 'Switch to dark'} style={{ color: darkMode ? '#ffa030' : 'rgba(255,255,255,0.45)' }}>
          {darkMode ? <Sun size={14} /> : <Moon size={14} />}
        </div>
        <div className="crm-top-icon" data-testid="logout-btn" onClick={logout} title={`Sign out ${user?.email || ''}`}><LogOut size={14} /></div>
        <div className="crm-avatar" data-testid="user-avatar" title={user?.email}>{initials}</div>
      </div>
    </div>
  );
};

export default Topbar;
